import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { NavLink, useLocation } from 'react-router-dom';
import { DiamondIcon } from '../../assets/DiamondIcon.tsx';
import { LogoBlack } from '../../assets/LogoBlack.tsx';
import { LogoWhite5 } from '../../assets/LogoWhite5.tsx';
import { GroupMemberRoleView } from '../../graphql/types.gen.ts';
import { useIsUserLoggedIn } from '../../helpers/useValidateToken.ts';
import { GENERAL_GROUP_NAME } from '../../index.tsx';
import { useHeaderInfoQuery } from '../../pages/FormPage/LoginPage/loginPage.gen.ts';
import './Header.scss';

interface IUserMenuItem {
    text: string;
    link: string;
    notify?: boolean;
    onlyForLoggedIn?: boolean;
}
export const Header = ({ formHeader = false, light = false }) => {
    const { isUserLoggedIn } = useIsUserLoggedIn();
    const location = useLocation();
    const dontAccessUser = ['/login', '/login/activated', '/signup', '/activate-account/', '/check-email', '/password-reset-request'].includes(location.pathname) || !isUserLoggedIn;
    const { data: chosenGroup } = useHeaderInfoQuery({
        variables: {
            input: {
                filters: {
                    reviewed: false,
                },
                pagination: {
                    limit: 100,
                    offset: 0,
                },
            },
        },
        skip: dontAccessUser,
    });
    const navigate = useNavigate();

    const groupCode = chosenGroup?.me?.recentlyUsedGroupId || GENERAL_GROUP_NAME;
    const points = chosenGroup?.me?.groups.find((group) => group.code === groupCode)?.me?.score || 0;
    const isInstructor = chosenGroup?.me?.groups.find((group) => group.code === groupCode)?.me?.role === GroupMemberRoleView.Instructor;
    const shouldNotify = chosenGroup?.me?.groups.find((group) => group.code === groupCode)?.joinRequests?.total > 0;

    const [wobbleClass, setWobbleClass] = useState('');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        if (location.pathname !== '/licytacja') return;
        setWobbleClass('wobble');
        setTimeout(() => {
            setWobbleClass('');
        }, 1000);
    }, [points]);

    const toggleMenu = () => {
        setIsMobileMenuOpen((prev) => !prev);
    };

    const USER_MENU: IUserMenuItem[] = [
        { text: 'Nauka', link: '/nauka' },
        { text: 'Testy', link: '/licytacja' },
        { text: 'Profil', link: '/profil', onlyForLoggedIn: true },
    ];
    const BACKOFFICE_MENU: IUserMenuItem[] = [
        { text: 'Nauka', link: '/nauka' },
        { text: 'Testy', link: '/licytacja' },
        { text: 'Edytuj testy', link: '/backoffice' },
        { text: 'Studenci', link: '/studenci', notify: shouldNotify },
        { text: 'Profil', link: '/profil' },
    ];

    const CHOSEN_MENU = isInstructor ? BACKOFFICE_MENU : USER_MENU;

    return (
        <>
            <div className="header">
                <div className="header__inner">
                    <button
                        onClick={() => {
                            navigate('/');
                        }}
                        className="header__item"
                    >
                        <div className="header__logo">{light ? <LogoBlack /> : <LogoWhite5 />}</div>
                    </button>
                    <button className={`header__mobileTrigger ${isMobileMenuOpen && !formHeader ? 'header__mobileTrigger--opened' : ''}`} onClick={toggleMenu}>
                        <div className="header__hamburger"></div>
                        <div className="header__hamburger"></div>
                        <div className="header__hamburger"></div>
                    </button>
                    <ul className={`header__mobileMenu ${isMobileMenuOpen && !formHeader ? 'header__mobileMenu--opened' : ''}`}>
                        <li className="header__mobileMenu__item">
                            <NavLink className="header__mobileMenu__link" to="/">
                                Strona główna
                            </NavLink>
                        </li>
                        {CHOSEN_MENU.map(
                            (item) =>
                                (!item?.onlyForLoggedIn || isUserLoggedIn) && (
                                    <li key={item.text.toLocaleLowerCase() + 'mobile'} className="header__mobileMenu__item">
                                        <NavLink className={`header__mobileMenu__link ${item?.notify ? 'header__mobileMenu__link--notify' : ''}`} to={item.link}>
                                            {item.text}
                                        </NavLink>
                                    </li>
                                )
                        )}
                        {!isUserLoggedIn && (
                            <li className="header__mobileMenu__item">
                                <NavLink key="login" className="header__mobileMenu__link" to="/login">
                                    Zaloguj się
                                </NavLink>
                            </li>
                        )}
                    </ul>
                    <div className={`header__items header__desktop ${formHeader ? ' header__items--hide' : ''}`}>
                        {CHOSEN_MENU.map((item) => {
                            return (
                                (!item?.onlyForLoggedIn || isUserLoggedIn) && (
                                    <NavLink key={item.text.toLocaleLowerCase()} className={`header__item ${item?.notify ? 'header__item--notify' : ''}`} to={item.link}>
                                        {item.text}
                                    </NavLink>
                                )
                            );
                        })}
                        {isUserLoggedIn ? (
                            <div className="header__user-wrapper">
                                <div className={`header__user-points-wrapper ${wobbleClass}`}>
                                    <p className="header__user-points">{points}</p>
                                    <div className="header__user-diamond">
                                        <DiamondIcon />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <NavLink key="login" className="header__item" to="/login">
                                Zaloguj się
                            </NavLink>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
